import { atom } from "recoil"

export const groupDetailRequestIdState = atom<number>({
  key: "atoms/organization/group/groupDetailRequestIdState",
  default: 0,
})
